<template>
  <v-container class="p-order-detail">
    <v-layout v-if="policy">
      <v-flex>
         <TK :policy="policy" v-if="this.productId == 1074"></TK>
         <ZF :policy="policy" v-else-if="this.productId == 1075"></ZF> 
      </v-flex>
      <v-flex class="operation ml-2" v-if="this.productId == 1074">
        <v-layout class="card app-bg" column justify-center v-pin="{padding: {top: 24}}">
          <v-flex class="text-xs-center mb-4">
            <span class="font-weight-medium primary-text" v-if="policy.policy && policy.policy.status === 0">待支付</span>
            <span class="font-weight-medium" v-else-if="policy.policy && policy.policy.status === 1">已出单</span>
            <span class="font-weight-medium" v-else>未知</span>
          </v-flex>
          <v-flex>
            总保费
            <span class="money primary-text" v-if="policy.policy">￥{{ policy.policy.amounts.toFixed(2) }}</span>
          </v-flex>
          <v-flex class="my-3">
            <hr />
          </v-flex>
          <v-flex>
            <v-btn
              color="primary"
              block
              large
              v-if="policy.policy && policy.policy.status === 0"
              @click="toPay()"
            >立即支付</v-btn>
            <!-- <v-btn
              class="operation-btn-large"
              color="primary"
              block
              large
              v-if="policy.status === 1"
              @click="change"
            >
              <v-layout column>
                <v-flex>变更员工信息</v-flex>
                <v-flex class="caption">（增员、减员、换人）</v-flex>
              </v-layout>
            </v-btn> -->
          </v-flex>
          <v-flex v-if="policy.policy && policy.policy.status === 1">
            <v-btn
              :to="'/order/add/'+policyCode+'?policyNo='+ policy.policy.code"
              color="primary"
              block
              large
            ><img src="/images/add.png" class="icon-font"/>增员</v-btn>
            <v-btn
              :to="'/order/reduce/'+policyCode+'?policyNo='+ policy.policy.code"
              color="primary"
              block
              large
            ><img src="/images/reduce.png" class="icon-font"/>减员</v-btn>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TK from "./components/tkDetil";
import ZF from "./components/zfDetil";
export default {
  props: {
    policyCode: String
  },
  components: {
    TK,
    ZF
  },
  data() {
    return {
      policy: null,
      urlData:[
        {
          productId:1074,
          url:'/app/api/tk/queryDetail'
        },
        {
          productId:1075,
          url:'/app/api/zhufeng/detail'
        }
      ],
      userId:null
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    productId() {
      return this.$route.query.productId;
    },
    apiUrl(){
      return this.urlData.find(item => item.productId == this.productId).url;
    }
  },
  created() {
    this.$store.dispatch("getUserInfo", true).then(user => {
      if (user) {
        this.userId = user.userId;
        this.getData();
      }
    });  
  },
  methods: {
    getData() {
      const json = {
        userId: this.businessId || this.userId,
        orderCode: this.policyCode
      };
      this.$axios
        .post(this.apiUrl, json)
        .then(res => {
          this.policy = res.data;
        })
        .catch(err => {
          this.$message.error("保单员工信息异常：" + err);
        });
    },
    toPay(){
      const orderCode = this.policy.policy.orderCode;
      this.$router.push({ name: "tkpay", params: { orderCode } });
    }
  }
};
</script>

<style lang="scss">
.p-order-detail {
  .download-link {
    font-size: 14px;
    color: $primary-color;
    margin-left: 15px;
  }
  .operation {
    width: 330px;
    flex: none;
    .card {
      padding: 30px 25px;
      margin-bottom: 20px;
      font-size: 14px;
      .money {
        font-size: 34px;
        line-height: 34px;
        font-weight: 500;
      }
    }
    &-btn-large {
      height: 60px;
    }
  }
  .section {
    padding: 40px 0;
    font-size: 14px;
    color: $font-color2;
    h4 {
      font-size: 18px;
      color: #222222;
      font-weight: 400;
    }
    &-row {
      margin: 15px 0;
      // .label {
      //   width: 100px;
      // }
      .short-item {
        display: flex;
      }
      span + span {
        margin-left: 1em;
      }
      .v-btn {
        margin-top: -7.5px;
      }
    }
  }
  .icon-font{
    width: 18px;
    height: 18px;
    margin-right: 7px;
  }
}
</style>

